import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotMoviesSection from './components/HotMoviesSection';
import FeaturesSection from './components/FeaturesSection';
import LatestSection from './components/LatestSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <HotMoviesSection />
        <FeaturesSection />
        <LatestSection />
      </main>
      <Footer />
    </>
  );
}